import { render, staticRenderFns } from "./SectionWhatXID.vue?vue&type=template&id=311b0bb9&scoped=true"
import script from "./SectionWhatXID.vue?vue&type=script&lang=ts"
export * from "./SectionWhatXID.vue?vue&type=script&lang=ts"
import style0 from "./SectionWhatXID.vue?vue&type=style&index=0&id=311b0bb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311b0bb9",
  null
  
)

export default component.exports